module.exports = __webpack_public_path__ + "static/img/08_01s.9f0c7d1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20250403/08_01s.gif
// module id = xO0F
// module chunks = 0